<div class="tab-pane" role="tabpanel" id="clasificacion">
    <fieldset id="agregar_clasificacion" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <div class="form-horizontal">
                        <form [formGroup]="form">
                            <h3  class="form-signin-heading"><strong>Caracteristicas principales del anteproyecto de loteo</strong></h3>
                            <div class="form-group">
                                <label for="num_lotes" class="col-md-2" align="left" style="padding-top: 20px;">N&uacute;mero lote</label>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Nº" id="num_lotes" name="num_lotes" formControlName="num_lotes" >
                                    </mat-form-field>
                                </div>
                                <label for="sup_lotes_enajenar" class="col-md-2" align="left" style="padding-top: 20px;">Superficie</label>
                                <div class="col-md-5">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="m2" id="sup_lotes_enajenar" name="sup_lotes_enajenar" formControlName="sup_lotes_enajenar" >
                                    </mat-form-field>
                                </div>
                                <label for="hoja_anexa" class="col-md-4" align="left" >Se adjunta hoja anexa (en caso de que sean mas lotes)</label>
                                <div>
                                    <mat-radio-group formControlName="hoja_anexa">
                                        <mat-radio-button style="padding-right: 20px" name="hoja_anexa" value="SI">SI</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="hoja_anexa" value="NO">NO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-top: 30px ; padding-bottom: 10px" align="center">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="ingreso_lotes" (click)="add_lotes_enajenar()">
                                        Agregar Lotes a enajenar
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
            <div class="datatable_lotes">
                <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>LOTES RESULTANTES</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.num_lotes}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>SU</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.sup_lotes_enajenar}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>OPCIONES</span>
                        </ng-template>
                        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                            <span (click)="get_lotes_enajenar(rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-pencil"></i></span>
                            <span (click)="delete_lotes_enajenar(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                        </ng-template>
                    </ngx-datatable-column>

                </ngx-datatable>


            </div>
        </div>
    </fieldset>

    <ng-template #openModal>
        <h2 mat-dialog-title>Informaci&oacute;n de las caracteristicas principales de los lotes</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="form-group">
                    <label class="col-md-4 control-label" for="num_anteproy_act">Lotes resultantes</label>
                    <div class="col-md-6">
                        <input id="id" name="id" type="hidden" placeholder="id" class="form-control input-md" [(ngModel)]="temp_carct_loteo.id">
                        <input id="num_lotes" name="num_lotes" type="text" placeholder="N&uacute;mero" class="form-control input-md" [(ngModel)]="temp_carct_loteo.num_lotes">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="sup_lotes_enajenar">Superficie</label>
                    <div class="col-md-6">
                        <input id="sup_lotes_enajenar" name="sup_lotes_enajenar" type="text" placeholder="sup_lotes_enajenar" class="form-control input-md" [(ngModel)]="temp_carct_loteo.sup_lotes_enajenar">
                    </div>
                    <div class="col-md-2"></div>
                </div>

            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_loteo" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_loteo" (click)="savelotes_enajenar()">Ingresar Loteo <i class="fa fa-user-o " aria-hidden="true "></i></button>
        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>
<div class="separator"></div>